import {ISingleEmpPersDetailsActionTypes,ISingleEmpPersDetailsActionCreator} from 'models/ISingleEmpPersDetails';
import ICurrentUserState from 'models/ICurrentUserState';

const initialState:ICurrentUserState = {}

const reducer = (state = initialState, { type, payload }: ISingleEmpPersDetailsActionCreator) => {
    switch (type) {
      case ISingleEmpPersDetailsActionTypes.FETCH_EMP_PERSONAL_DETAILS_LIST_REQUEST:
        return {
          ...state,
          data:{},
        }
      case ISingleEmpPersDetailsActionTypes.FETCH_EMP_PERSONAL_DETAILS_LIST_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;